/** A route only a holder of `permission` opens; anyone else goes home (SA-1103: AI models reads
 * `ai_models:read`, not `admin:access`). Before the permission store loads it lets the page
 * render, because the store answers yes until then. */
import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { usePermission } from '@/hooks/usePermission'

export function PermissionOnly({ permission, children }: { permission: string; children: ReactNode }) {
  const allowed = usePermission(permission)
  if (!allowed) return <Navigate to="/" replace />
  return <>{children}</>
}
